import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientNoteTemplate } from "@customTypes/patientNote";

import { patientNoteQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);

  if (res.data.length) {
    const newData: PatientNoteTemplate[] = [];

    for (const i in res.data) {
      const { _id, title, description, tags, type, label, value } = res.data[i];

      newData.push({
        id: _id,
        title,
        description,
        category: type,
        tags,
        label,
        value, // Backend uses underscores instead of hyphens for this
      });
    }

    // console.log(newData);
    return newData;
  }
  return null;
};

interface QueryProps {
  category: string;
  isEnabled?: boolean;
}

export const useGetPatientNoteTemplates = ({
  category,
  isEnabled,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: patientNoteQKeys.template(category),
    queryFn: () => {
      return api.get(`notes/templates`, {
        params: {
          note_type: category,
        },
      });
    },
    select,
    staleTime: Infinity,
    enabled: isEnabled,

    onError: (res: any) => {
      console.error("[From Get Patient Note Templates]", res);
      handleErrors(res, "query");
    },
  });
};
